import * as fromMapping from '../actions/mapping.action';

import { Mapped, MapperViewer, MappingOptions, MappingSetup, MasterModel } from '@usimweb/core/models';

export interface MappingState {
  mapping: Mapped;
  mappingOptions: MappingOptions;
  mappingSetup: { [id: string]: MappingSetup };
  masterModel: MasterModel;
  viewer: MapperViewer;
  // loaded: boolean;
  // loading: boolean;
}

export const initialState: MappingState = {
  mapping: {} as Mapped,
  mappingOptions: {} as MappingOptions,
  mappingSetup: {},
  masterModel: {} as MasterModel,
  viewer: {} as MapperViewer,
  // loaded: false,
  // loading: false,
};

export function reducer(state = initialState, action: fromMapping.MappingAction): MappingState {
  switch (action.type) {
    case fromMapping.LOAD_MAPPING: {
      return {
        ...state,
        //loading: true,
      };
    }

    case fromMapping.LOAD_MAPPING_FAIL: {
      return {
        ...state,
        //loading: false,
        //loaded: false,
      };
    }

    case fromMapping.LOAD_MAPPING_SUCCESS: {
      const mapping = action.payload;
      const masterModel = mapping.mastermodel;

      return {
        ...state,
        // loading: false,
        // loaded: true,
        mapping,
        masterModel,
      };
    }

    case fromMapping.LOAD_MASTER_MODEL: {
      const masterModel = action.payload;

      return {
        ...state,
        masterModel,
      };
    }

    case fromMapping.UPDATE_MAPPING_OPTIONS: {
      const mappingOptions = action.payload;
      return {
        ...state,
        mappingOptions,
      };
    }

    case fromMapping.UPDATE_MAPPING_SETUP: {
      const { id, updates } = action.payload; // Get the ID and updates

      return {
        ...state,
        mappingSetup: {
          ...state.mappingSetup,
          [id]: {
            ...state.mappingSetup[id], // Spread existing setup
            ...updates, // Apply updates
          },
        },
      };
    }

    case fromMapping.UPDATE_MAPPING_VIEW: {
      const viewer = action.payload;
      return {
        ...state,
        viewer: {
          ...state.viewer,
          ...viewer,
        },
      };
    }

    case fromMapping.UPDATE_MASTER_MODEL: {
      const masterModel = action.payload;
      return {
        ...state,
        masterModel: {
          ...state.masterModel,
          ...masterModel,
        },
      };
    }

    case fromMapping.CLEAR_MAPPING: {
      return {
        ...state,
        mapping: {} as Mapped,
        masterModel: {} as MasterModel,
      };
    }
  }

  return state;
}

export const getMapping = (state: MappingState) => state.mapping;
// export const getMappingLoading = (state: MappingState) => state.loading;
// export const getMappingLoaded = (state: MappingState) => state.loaded;
export const getMasterModel = (state: MappingState) => state.masterModel;
export const getMappingOptions = (state: MappingState) => state.mappingOptions;
export const getMappingSetup = (state: MappingState) => state.mappingSetup;
export const getViewer = (state: MappingState) => state.viewer;
